<div class="container" [ngSwitch]="mode">
  <div *ngSwitchCase="'form'">
    <app-template [title]="'Radiology Others'">
      <div class="search" style="padding-top: 30px">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input [(ngModel)]="name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Mobile No.</mat-label>
            <input type="number" [(ngModel)]="phone" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Gender</mat-label>
            <mat-select [(ngModel)]="sex" matNativeControl>
              <mat-option value="Male">Male</mat-option>
              <mat-option value="Female">Female</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field class="size">
            <mat-label>Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="dob"
              (dateChange)="startDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="dob"
            ></mat-datepicker-toggle>
            <mat-datepicker #dob></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field class="size">
            <mat-label>End Date</mat-label>
            <input
              matInput
              [matDatepicker]="end"
              (dateChange)="endDateChange($event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="end"
            ></mat-datepicker-toggle>
            <mat-datepicker #end></mat-datepicker>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Department</mat-label>
            <mat-select
              [(ngModel)]="dept_code"
              (selectionChange)="dept($event)"
              matNativeControl
            >
              <mat-option *ngFor="let dept of depts" [value]="dept.id">
                {{ dept.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <!-- <span class="input">
            <mat-form-field>
                <mat-label>Investigation</mat-label>
                <input [(ngModel)]="investigation" (ngModelChange)="itemChange($event)" matInput>
                <div class="float" style="position: relative; width: 3px;">
                  <div class="ret" *ngIf="drVisible" >
                    <div class="list" (click)="setitem(item)" *ngFor="let item of filterddata">{{item.name}}</div>
                  </div>
                </div>
              </mat-form-field>
          </span> -->
        <div>
          <button
            (click)="getResult()"
            style="margin-bottom: 30px; margin-left: 30px; margin-top: 15px"
            mat-raised-button
            color="primary"
          >
            Search
          </button>
        </div>
      </div>
      <div class="data">
        <div class="color-code">
          <div class="color-title">
            Typed:
            <div style="background-color: #971ce2"></div>
          </div>
          <div class="color-title">
            Finalized:
            <div style="background-color: limegreen"></div>
          </div>
          <div class="color-title">
            Printed:
            <div style="background-color: #1408cb"></div>
          </div>
          <div class="color-title">
            Pushed Online:
            <div style="background-color: #de7813"></div>
          </div>
        </div>
        <div *ngIf="isLoading" style="margin-top: 50px" class="spinner">
          <mat-spinner></mat-spinner>
        </div>
        <table *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Test ID</th>
            <th>Date</th>
            <th>Dept Name</th>
            <th>Service Name</th>
            <th>Patient Name</th>
            <th>Status</th>
            <th>
              <!-- <button  mat-raised-button color="basic">
                          Clear All
                        </button> -->
            </th>
          </tr>
          <tr *ngFor="let item of data" style="cursor: pointer">
            <td>{{ item.sample_id }}</td>
            <td [ngClass]="{ active: item.selected }">
              <span
                *ngIf="isWithinLastWeek(item.service.bill_date)"
                style="
                  color: white;
                  background-color: blue;
                  border-radius: 7px;
                  padding: 1px 5px;
                "
              >
                New </span
              ><br />
              {{ item.service.bill_date | date }}<br />
              <b>{{ item.result_time }}</b>
            </td>
            <td>{{ item.department_name }}</td>
            <td>{{ item.service_name }}</td>
            <td>{{ item.patient_name }}</td>
            <td [ngClass]="getRowClass(item)">
              <p
                class="statspn"
                style="font-weight: 600"
                *ngIf="item.service.prepared == 'Y'"
              >
                Result Typed at
                {{
                  item.service.prepared_timestamp | date : "yyyy-MM-dd HH:mm a"
                }}
              </p>

              <p
                class="statspn"
                style="font-weight: 600"
                *ngIf="item.service.finalized == 'Y'"
              >
                Result Finalized at
                {{
                  item.service.finalized_timestamp | date : "yyyy-MM-dd HH:mm a"
                }}
              </p>
              <p
                class="statspn"
                style="font-weight: 600"
                *ngIf="item.pushedOnlineStatus"
                style="font-weight: 600"
              >
                {{ item.pushedOnlineStatus }}
              </p>
              <p
                class="statspn"
                *ngIf="item.service.printed == 'Y'"
                style="font-weight: 600"
              >
                Result Printed
              </p>
            </td>
            <td>
              <div class="dropdown">
                <button class="dropbtn" mat-raised-button>Actions</button>
                <div class="dropdown-content">
                  <a class="dropdown-item" (click)="addRecord(item)"
                    >View Format</a
                  >
                  <!-- <a class="dropdown-item" (click)="SendReviewAction(item)"
                    >Send For Review</a
                  > -->
                </div>
              </div>
            </td>
          </tr>
        </table>
        <app-pagination [currentPage]="currentPage" [totalSize]="totalSize" 
        [pageSize]="pageSize" (pageChanged)="onPageChanged($event)"></app-pagination>
      </div>
    </app-template>
  </div>
  <div class="wizwig" *ngSwitchCase="'wiz'">
    <app-template [title]="'Format Result'">
      <div class="form">
        <div style="display: flex">
          <span class="input">
            <mat-form-field>
              <mat-label>Template</mat-label>
              <mat-select matNativeControl required>
                <mat-option *ngIf="isLoading">Loading Data</mat-option>
                <mat-option
                  *ngFor="let template of templates"
                  (click)="setTemplate(template)"
                  [value]="template.Id"
                >
                  {{ template.Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
          <div style="margin-left: 30px">
            <mat-form-field>
              <mat-label>Select Finalizer.</mat-label>
              <mat-select
                matNativeControl
                [(ngModel)]="dr"
                required
                (selectionChange)="drValue($event)"
              >
                <mat-option *ngFor="let data of drs" [value]="data.Employee_id">
                  {{ data.First_Name }} {{ data.Middle_Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div style="margin-left: 30px">
            <mat-form-field>
              <mat-label>Select Initializer.</mat-label>
              <mat-select
                matNativeControl
                [(ngModel)]="initialdr"
                required
                (selectionChange)="initatorValue($event)"
              >
                <mat-option *ngFor="let data of drs" [value]="data.Employee_id">
                  {{ data.First_Name }} {{ data.Middle_Name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <!-- <span>
          <div class="sign">
            <div class="custom-file fileInputProfileWrap">
              <input
                type="file"
                (change)="fileChangeEvent($event)"
                class="fileInputProfile"
              />
            </div>
          </div>
          <ng-container *ngIf="message">
            <a
              *ngFor="let image of message"
              style="margin: 10px"
              target="blank"
              [href]="image.fileUrl"
              >View File</a
            >
          </ng-container>
        </span> -->

        <div>
          <button
            class="create"
            mat-raised-button
            color="primary"
            (click)="finalize()"
          >
            <span *ngIf="!finalizeLoading">Finalizer</span>
            <span *ngIf="finalizeLoading"
              ><i class="fa fa-spinner fa-spin" aria-hidden="true"></i
            ></span>
          </button>

          <!-- <button
            (click)="openFinalize()"
            mat-raised-button
            color="primary"
            style="margin-left: 20px"
          >
            Select Finalizer and Initializer
          </button> -->
        </div>
        <div
          id="print-section"
          style="display: none; width: 500px; margin: auto"
          [innerHTML]="Template_Text"
        ></div>
        <div class="space"></div>
        <quill-editor
          [(ngModel)]="Template_Text"
          [styles]="{ height: '300px' }"
        ></quill-editor>

        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
            <p>{{ Errors }}</p>
          </div>
        </div>
        <button
          (click)="back()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Back
        </button>
        <button
          class="create"
          mat-raised-button
          color="primary"
          (click)="SendReview()"
        >
          Send For Review
        </button>

        <button
          (click)="done()"
          class="create"
          mat-raised-button
          color="primary"
        >
          Add
        </button>
        <button
          (click)="Submit()"
          *ngIf="!sendLoad"
          class="create"
          mat-raised-button
          color="primary"
        >
          Save
        </button>
        <button
          (click)="Submit()"
          *ngIf="sendLoad"
          class="create"
          mat-raised-button
          color="primary"
        >
          <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
        </button>
        <div class="space"></div>
        <img style="width: 100%" [src]="file" alt="" />
      </div>
    </app-template>
  </div>
</div>
